module.exports = __webpack_public_path__ + "static/img/brandorg.b167e4b1.jpg";